import * as Types from '../../tenants/kwg/generated';

import { RoleAssignmentWithDetailsFragmentDoc } from './roleAssignments.fragment.g';
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';


export const ObjectRoleAssignmentsDocument = `
    query ObjectRoleAssignments($order: [RoleAssignmentSortInput!], $first: Int, $after: String, $where: RoleAssignmentFilterInput) {
  roleAssignments(order: $order, first: $first, after: $after, where: $where) {
    edges {
      node {
        ...RoleAssignmentWithDetails
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${RoleAssignmentWithDetailsFragmentDoc}`;

export const useObjectRoleAssignmentsQuery = <
      TData = Types.ObjectRoleAssignmentsQuery,
      TError = unknown
    >(
      variables?: Types.ObjectRoleAssignmentsQueryVariables,
      options?: Omit<UseQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.ObjectRoleAssignmentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ObjectRoleAssignments'] : ['ObjectRoleAssignments', variables],
    queryFn: fetcher<Types.ObjectRoleAssignmentsQuery, Types.ObjectRoleAssignmentsQueryVariables>(ObjectRoleAssignmentsDocument, variables),
    ...options
  }
    )};

export const useSuspenseObjectRoleAssignmentsQuery = <
      TData = Types.ObjectRoleAssignmentsQuery,
      TError = unknown
    >(
      variables?: Types.ObjectRoleAssignmentsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<Types.ObjectRoleAssignmentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ObjectRoleAssignments'] : ['ObjectRoleAssignments', variables],
    queryFn: fetcher<Types.ObjectRoleAssignmentsQuery, Types.ObjectRoleAssignmentsQueryVariables>(ObjectRoleAssignmentsDocument, variables),
    ...options
  }
    )};

export const useInfiniteObjectRoleAssignmentsQuery = <
      TData = InfiniteData<Types.ObjectRoleAssignmentsQuery>,
      TError = unknown
    >(
      variables: Types.ObjectRoleAssignmentsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<Types.ObjectRoleAssignmentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ObjectRoleAssignments.infinite'] : ['ObjectRoleAssignments.infinite', variables],
      queryFn: (metaData) => fetcher<Types.ObjectRoleAssignmentsQuery, Types.ObjectRoleAssignmentsQueryVariables>(ObjectRoleAssignmentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

export const useSuspenseInfiniteObjectRoleAssignmentsQuery = <
      TData = InfiniteData<Types.ObjectRoleAssignmentsQuery>,
      TError = unknown
    >(
      variables: Types.ObjectRoleAssignmentsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<Types.ObjectRoleAssignmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<Types.ObjectRoleAssignmentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ObjectRoleAssignments.infinite'] : ['ObjectRoleAssignments.infinite', variables],
      queryFn: (metaData) => fetcher<Types.ObjectRoleAssignmentsQuery, Types.ObjectRoleAssignmentsQueryVariables>(ObjectRoleAssignmentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};
